import React from "react";
import PropTypes from "prop-types";
import { Avatar, Flex } from "@evertrue/et-components";
import classNames from "classnames";

const AVATAR_WIDTH = 40;

const ChatContactCard = ({ className, contact, hideName, children }) => {
  return (
    <Flex className={classNames("chat-contact-card", className)} alignItems="center">
      <Avatar url={contact.avatar} name={contact.name} width={AVATAR_WIDTH} />
      <div className="chat-contact-card--name">{contact.name}</div>
    </Flex>
  );
};

ChatContactCard.propTypes = {
  className: PropTypes.string,
  contact: PropTypes.object,
  hideName: PropTypes.bool,
  children: PropTypes.any,
};

export default ChatContactCard;
